import { render, staticRenderFns } from "./DunningLetter.yaml?vue&type=template&id=6754e2c5&component"
import script from "./DunningLetter.yaml?vue&type=script&lang=ts&component"
export * from "./DunningLetter.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports